import { useFutureStore } from '~/store/future'
import { usePanelStore } from '~/store/panel'
import Decimal from 'decimal.js-light'
import { fixRaw } from '#imports'
import { toValue } from 'vue'

export const initTpsl = {
  triggerValueType: 'ror',
  priceType: 'MARKET',
  sliderValue: 0,
  triggerPrice: '',
  triggerValue: '',
  price: '',
  orderSubType: 2,
}

export function useTpsl() {
  const future = useFutureStore()
  const panel = usePanelStore()

  function inferPriceByValue({
    triggerValue,
    triggerValueType = 'ror',
    side,
    lots,
    price,
    leverage,
    code,
  }) {
    side = toValue(side)
    lots = toValue(lots)
    price = toValue(price)
    leverage ||= future.positionConfig.leverage
    price ||= panel.getPriceBySide({ side }) // 委托价格
    const curInfo = future.getInfo(code || future.code)
    const isLong = side === 1
    if (!+price || !triggerValue)
      return ''

    if (triggerValueType === 'ror') {
      // ror = ((触发价格 - 委托价格) / 委托价格) * leverage
      return isLong ? Decimal(triggerValue || 0).div(100).div(leverage).plus(1).mul(price).toFixed() : Decimal(1).minus(Decimal(triggerValue || 0).div(100).div(leverage)).mul(price).toFixed()
    }
    else if (triggerValueType === 'pcp') {
      // pcp = (触发价格 - 委托价格) / 委托价格
      return isLong ? Decimal(triggerValue || 0).div(100).plus(1).mul(price).toFixed() : Decimal(1).minus(Decimal(triggerValue || 0).div(100)).mul(price).toFixed()
    }
    else if (triggerValueType === 'pnL') {
      // npl = (触发价格 - 委托价格) * 张 * size
      if (!+lots)
        return ''
      return isLong ? Decimal(triggerValue || 0).div(future.curInfo.contractSize).div(lots).plus(price).toFixed() : Decimal(price).minus(Decimal(triggerValue || 0).div(curInfo.contractSize).div(lots)).toFixed()
    }
    else if (triggerValueType === 'price') {
      return triggerValue
    }
  }

  function inferValueByPrice({
    triggerPrice,
    triggerValueType = 'ror',
    side,
    lots,
    price,
    leverage,
    code,
  }) {
    side = toValue(side)
    lots = toValue(lots)
    price = toValue(price)
    leverage ||= future.positionConfig.leverage
    price ||= panel.getPriceBySide({ side }) // 委托价格
    const curInfo = future.getInfo(code || future.code)
    if (!price || !triggerPrice)
      return ''

    if (triggerValueType === 'ror') {
      // ror = ((触发价格 - 委托价格) / 委托价格) * leverage
      return Decimal(triggerPrice).minus(price).div(price).mul(100).mul(future.positionConfig.leverage).mul(side).toFixed()
    }
    else if (triggerValueType === 'pcp') {
      // pcp = (触发价格 - 委托价格) / 委托价格
      return Decimal(triggerPrice).minus(price).div(price).mul(100).mul(side).toFixed()
    }
    else if (triggerValueType === 'pnL') {
      // npl = (触发价格 - 委托价格) * 张 * size
      if (!+lots)
        return ''
      return Decimal(triggerPrice).minus(price).mul(lots).mul(curInfo.contractSize).mul(side).toFixed()
    }
  }

  return { inferPriceByValue, inferValueByPrice }
}
